import React, { useEffect, useState } from "react";
import { RefreshCcw, Loader2 } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const todayAt4pm = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T16:00`;
};

export const FreshStart = () => {
  const [state, setState] = useState(null);
  const [startAt, setStartAt] = useState(todayAt4pm());
  const [busy, setBusy] = useState(false);
  const load = async () => {
    try { setState((await api.get("/admin/fresh-start")).data); } catch (e) { toast.error(formatError(e)); }
  };
  useEffect(() => { load(); }, []);

  const run = async () => {
    const when = new Date(startAt);
    if (!window.confirm(`Archive ALL current shipments, remove their collections, fund requests and liquidations, and only import emails sent from ${when.toLocaleString()} onward?`)) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/fresh-start", { start_at: when.toISOString() });
      toast.success(`${data.archived} shipment(s) archived, ${data.finance_removed} finance record(s) removed`);
      load();
    } catch (e) { toast.error(formatError(e)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="fresh-start-card" className="glass-card rounded-lg p-6">
      <div className="flex items-center gap-2 text-slate-200 font-display text-xl mb-2">
        <RefreshCcw size={18} className="text-rose-400" /> Fresh Start
      </div>
      <p className="text-sm text-slate-400 mb-4">
        Moves every current shipment to the Archive, removes the collections, fund requests and liquidations linked to them, and makes the inbox ignore emails sent before the start time.
      </p>
      <div className="flex flex-col sm:flex-row sm:items-end gap-3">
        <div>
          <Label>Import emails sent from</Label>
          <Input data-testid="input-fresh-start-at" type="datetime-local" value={startAt} onChange={(e) => setStartAt(e.target.value)}
                 className="bg-slate-950 border-slate-700" />
        </div>
        <Button data-testid="button-fresh-start" onClick={run} disabled={busy || !startAt} className="bg-rose-600 hover:bg-rose-500">
          {busy ? <Loader2 size={14} className="mr-2 animate-spin" /> : <RefreshCcw size={14} className="mr-2" />} Archive all & start fresh
        </Button>
      </div>
      {state?.start_at && (
        <div data-testid="fresh-start-status" className="text-xs text-slate-500 mt-3">
          Inbox imports emails sent from {new Date(state.start_at).toLocaleString()} · last run {new Date(state.done_at).toLocaleString()} by {state.done_by_name} ({state.archived} archived, {state.finance_removed} finance records removed)
        </div>
      )}
    </div>
  );
};
